import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';
import { IconStarFilled } from '@xing-com/icons';

import { useUnfeatureArticleMutation } from '../../../../hooks/use-unfeature-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleUnfeatureButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
}) => {
  const { showError } = useErrorContext();

  const [makeArticleUnfeatured, { loading }] = useUnfeatureArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = async () => {
    try {
      await makeArticleUnfeatured({ input: { globalId: article.globalId } });
    } catch (error) {
      showError({ message: error.message, error });
    }
  };

  return (
    <Styled.Button
      data-testid={`ARTICLE-UNFEATURE-BUTTON-${article.id}`}
      icon={IconStarFilled}
      size="small"
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
    />
  );
};
